module.exports = __webpack_public_path__ + "static/media/background.bfa21ae8.png";